export function saveScrollPosition(this: HTMLElement, e: Event): void {
    e.stopPropagation();
    const scrollPosition = document.querySelector('.admin-sidebar_content').scrollTop;
    sessionStorage.setItem('scrollPosition', scrollPosition.toString());
}

export function loadScrollPosition(): void {
    const scrollPosition = sessionStorage.getItem('scrollPosition')
    const adminSidebarContent = document.querySelector('.admin-sidebar_content');
    if (scrollPosition && adminSidebarContent) {
        adminSidebarContent.scrollTo(0, parseInt(scrollPosition));
    }
}
